// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ITemplateVariableDto } from './ITemplateVariableDto';
import {
    ITemplateVariableDtoFromJSON,
    ITemplateVariableDtoFromJSONTyped,
    ITemplateVariableDtoToJSON,
    ITemplateVariableDtoToJSONTyped,
} from './ITemplateVariableDto';

/**
 * 
 * @export
 * @interface IValueTemplateDto
 */
export interface IValueTemplateDto {
    /**
     * 
     * @type {string}
     * @memberof IValueTemplateDto
     */
    template?: IValueTemplateDtoTemplateEnum;
    /**
     * 
     * @type {number}
     * @memberof IValueTemplateDto
     */
    version?: number;
    /**
     * 
     * @type {{ [key: string]: ITemplateVariableDto; }}
     * @memberof IValueTemplateDto
     */
    variables?: { [key: string]: ITemplateVariableDto; };
}

/**
* @export
* @enum {string}
*/
export enum IValueTemplateDtoTemplateEnum {
    HSA_ACCOUNT_LINK_AP = 'HSA_ACCOUNT_LINK_AP',
    DOCUMENT_RENDER = 'DOCUMENT_RENDER',
    DEFAULT = 'DEFAULT'
}


/**
 * Check if a given object implements the IValueTemplateDto interface.
 */
export function instanceOfIValueTemplateDto(value: object): value is IValueTemplateDto {
    return true;
}

export function IValueTemplateDtoFromJSON(json: any): IValueTemplateDto {
    return IValueTemplateDtoFromJSONTyped(json, false);
}

export function IValueTemplateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IValueTemplateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'template': json['template'] == null ? undefined : json['template'],
        'version': json['version'] == null ? undefined : json['version'],
        'variables': json['variables'] == null ? undefined : (mapValues(json['variables'], ITemplateVariableDtoFromJSON)),
    };
}

export function IValueTemplateDtoToJSON(json: any): IValueTemplateDto {
    return IValueTemplateDtoToJSONTyped(json, false);
}

export function IValueTemplateDtoToJSONTyped(value?: IValueTemplateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'template': value['template'],
        'version': value['version'],
        'variables': value['variables'] == null ? undefined : (mapValues(value['variables'], ITemplateVariableDtoToJSON)),
    };
}

